import Accordion from 'react-bootstrap/Accordion';

function FaqsAccordion({ elements }) {
  return (
    <Accordion defaultActiveKey="0">
      {elements?.map((element, index) => (
        <Accordion.Item eventKey={index} key={index} className={index === elements.length - 1? 'twyny-border-b':''}>
          <Accordion.Header className='body bold500 grey500'>{element.question}</Accordion.Header>
          <Accordion.Body className='body grey66 mt-8 pt-0'>
            {element.answer}
          </Accordion.Body>
        </Accordion.Item>
      ))}
    </Accordion>
  );
}

export default FaqsAccordion;